import { Document, Page, StyleSheet } from "@react-pdf/renderer";
import { MedicationSimpleRecipe } from "./MedicationSimpleRecipe";
import { MedicationSpecialControl } from "./MedicationSpecialControl";
import { ExamSolicitation } from "./ExamSolicitation";
import { MedicalCertificate } from "./MedicalCertificate";
import { ProcedureRecipe } from "./ProcedureRecipe";

const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#f9f9f9",
    width: "100%",
    padding: "180px 40px",
  },
});

export function PDFRender({
  dataPdf,
  content,
  setBlob,
  blob,
  dataRegister,
  gender,
}: any) {
  const filterSimple =
    dataRegister?.filter(
      (auxSimple: any) =>
        auxSimple?.resource?.item?.[0]?.answer?.[0]?.valueString === "simple"
    ) || [];

  const filterSpecial =
    dataRegister?.filter(
      (auxSimple: any) =>
        auxSimple?.resource?.item?.[0]?.answer?.[0]?.valueString === "special"
    ) || [];

  const filterProcedure =
    dataRegister?.filter(
      (auxSimple: any) =>
        auxSimple?.resource?.item?.[0]?.answer?.[0]?.valueString === "procedure"
    ) || [];

  const filterExam =
    dataRegister?.filter(
      (auxSimple: any) =>
        auxSimple?.resource?.item?.[0]?.answer?.[0]?.valueString === "exam"
    ) || [];

  const filterCertificate =
    dataRegister?.filter(
      (auxSimple: any) =>
        auxSimple?.resource?.item?.[0]?.answer?.[0]?.valueString ===
        "certificate"
    ) || [];
  return (
    <Document
      onRender={(props) => {
        if (!blob) {
          setBlob((prev: any) => ({
            ...prev,
            [content?.type]: { blob: props?.blob, info: content?.data },
          }));
        }
      }}
      style={{ width: "100%" }}
    >
      {content?.type === "simple" && (
        <Page wrap={true} size="A4" style={styles.page}>
          <MedicationSimpleRecipe
            gender={gender}
            filterMedication={content?.data}
            dataPdf={dataPdf}
            documentHasBackground={filterSimple.length ? true : false}
            imgBase64={`data:${
              filterSimple?.[0]?.resource?.item?.[2]?.answer?.[0]
                ?.valueAttachment?.contentType
            };base64,${
              filterSimple?.[0]?.resource?.item?.[2]?.answer?.[0]
                ?.valueAttachment?.data ?? ""
            }`}
          />
        </Page>
      )}
      {content?.type.includes("special") && (
        <MedicationSpecialControl
          gender={gender}
          filterSpecialMedication={content?.data}
          dataPdf={dataPdf}
          documentHasBackground={filterSpecial.length ? true : false}
          imgBase64={`data:${
            filterSpecial?.[0]?.resource?.item?.[2]?.answer?.[0]
              ?.valueAttachment?.contentType
          };base64,${
            filterSpecial?.[0]?.resource?.item?.[2]?.answer?.[0]
              ?.valueAttachment?.data ?? ""
          }`}
        />
      )}
      {content?.type.includes("procedure") && (
        <Page wrap={true} size="A4" style={styles.page}>
          <ProcedureRecipe
            gender={gender}
            filterProcedure={content?.data}
            dataPdf={dataPdf}
            documentHasBackground={filterProcedure.length ? true : false}
            imgBase64={`data:${
              filterProcedure?.[0]?.resource?.item?.[2]?.answer?.[0]
                ?.valueAttachment?.contentType
            };base64,${
              filterProcedure?.[0]?.resource?.item?.[2]?.answer?.[0]
                ?.valueAttachment?.data ?? ""
            }`}
          />
        </Page>
      )}
      {content?.type === "exam" && (
        <Page wrap={true} size="A4" style={styles.page}>
          <ExamSolicitation
            gender={gender}
            filterExam={content?.data}
            dataPdf={dataPdf}
            documentHasBackground={filterExam.length ? true : false}
            imgBase64={`data:${
              filterExam?.[0]?.resource?.item?.[2]?.answer?.[0]?.valueAttachment
                ?.contentType
            };base64,${
              filterExam?.[0]?.resource?.item?.[2]?.answer?.[0]?.valueAttachment
                ?.data ?? ""
            }`}
          />
        </Page>
      )}
      {content?.type.includes("certificate") && (
        <Page wrap={true} size="A4" style={styles.page}>
          <MedicalCertificate
            gender={gender}
            filterMedicalCertificate={content?.data}
            dataPdf={dataPdf}
            documentHasBackground={filterCertificate.length ? true : false}
            imgBase64={`data:${
              filterCertificate?.[0]?.resource?.item?.[2]?.answer?.[0]
                ?.valueAttachment?.contentType
            };base64,${
              filterCertificate?.[0]?.resource?.item?.[2]?.answer?.[0]
                ?.valueAttachment?.data ?? ""
            }`}
          />
        </Page>
      )}
    </Document>
  );
}
